module.exports = require("@swa-ui/shopping/src/SwaBizToggle/SwaBizToggle.module.scss");